import script from "./JsonTreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonTreeItem.vue?vue&type=script&setup=true&lang=js"

import "./JsonTreeItem.vue?vue&type=style&index=0&id=2a1336b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1336b8"]])

export default __exports__